import script from "./ChangeGeoblockModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeGeoblockModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeGeoblockModal.vue?vue&type=style&index=0&id=5e5000f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5000f8"]])

export default __exports__